import CloseModal from './CloseModal.component';

export default CloseModal;
